import { sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';

export function getLicenseExtraInfo(productName, maxDate) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_license_extra_info',
        product_name: productName,
        max_date: maxDate,
      })
    }
  );
}



// WEBPACK FOOTER //
// ./src/services/licensesCommon.js